import React, { useEffect, useCallback, useState } from 'react';
import UserRelationGroupStatuses from '../../enums/UserRelationGroupStatuses';
import { useForm } from 'react-hook-form';
import {
    Col,
    Button,
    FormGroup,
    Label,
    Form,
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import Select from 'react-select';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function ModalAssignToSenior(props) {
    const { modal, toggleModal, giver, groupId, isModalOpen, loadCallback } = props;

    const [receivers, setReceivers] = useState([]);
    const { register, handleSubmit, reset } = useForm({});
    const { toggleLoading } = useAuth();

    const [selectedReceivers, setSelectedReceivers] = useState([]);

    const onSubmitAssign = useCallback(
        async (data) => {
            if (selectedReceivers && selectedReceivers.length > 0) {
                selectedReceivers.forEach((receiver) => {
                    toggleLoading(true);
                    api.post('ro.team.assignGiverToReceiver', {
                        givid: data.giver_id,
                        recid: receiver.value,
                        id: groupId,
                    })
                        .then((response) => {
                            toast.success(
                                `${giver.name} was assigned to a senior!`
                            );
                            toggleModal();
                            reset(response);
                            loadCallback();
                        })
                        .catch((err) => {
                            toast.error(err.response.data.message);
                        })
                        .finally(() => {
                            toggleLoading(false);
                        });
                });
            }
        },
        [toggleModal, groupId, reset, giver.name, toggleLoading, loadCallback, selectedReceivers]
    );

    useEffect(() => {
        if (isModalOpen) {
            api.post(`/ro.team.listReceiversGroup/${groupId}`).then((response) => {
                const filtered = response.data.items.filter((giver) => {
                    return (
                        parseInt(giver.status.code) ===
                            UserRelationGroupStatuses.ACCEPTED_BY_CHILD ||
                        parseInt(giver.status.code) ===
                            UserRelationGroupStatuses.ACCEPTED_BY_PARENT
                    );
                });
                setReceivers(filtered);
            });
        }
    }, [groupId, isModalOpen, setReceivers]);

    const options = useCallback(() => {
        let options = [];
        // eslint-disable-next-line
        if (receivers) {
            receivers.forEach((receiver) => {
                let giverLabel = '';
                if(receiver.givers && receiver.givers.length>0 && receiver.givers[0].id &&  receiver.givers[0].name) {
                    giverLabel = `  (v: ${receiver.givers[0].name})`;
                }
                options.push(
                    {
                        value: receiver.id,
                        label: receiver.name + giverLabel
                    }
                )
            });
        }
        
        return options;
    }, [receivers]);

    return (
        <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>
                Assign '{giver.name}' to Senior
            </ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup row>
                        <Label for="name" sm={2}>
                            Name
                        </Label>
                        <Col sm={10}>
                            <input
                                type="text"
                                name="name"
                                id="name"
                                ref={register}
                                className="form-control"
                                disabled={true}
                                value={giver.name}
                            />

                            <input
                                type="hidden"
                                name="giver_id"
                                id="giver_id"
                                ref={register}
                                value={giver.id}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label for="receiver_id" sm={2}>
                            Senior
                        </Label>
                        <Col sm={10}>
                            <Select
                                name="receiver_id"
                                id="receiver_id"
                                options={options()}
                                placeholder="Select a Senior"
                                inputRef={register}
                                className="z-index-10"
                                isMulti
                                onChange={(e) => {
                                    setSelectedReceivers(e);
                                }}
                            />
                            {/* <select
                                name="receiver_id"
                                id="receiver_id"
                                ref={register}
                                className="form-control"
                            >
                                {receivers &&
                                    receivers.map((receiver) => (
                                        <option value={receiver.id} key={receiver.id}>
                                            {receiver.name}
                                        </option>
                                    ))}
                            </select> */}
                        </Col>
                    </FormGroup>

                    <FormGroup check row>
                        <Col
                            sm={{
                                size: 15,
                                offset: 2,
                            }}
                        >
                            <Button
                                color="success"
                                onClick={handleSubmit(onSubmitAssign)}
                            >
                                Assign
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
    );
}
